import React from 'react';
import { AccordionContainer } from '../../../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../../../common/components/form/form.module';

export const AccountUserBasicInfoComponent = ({
    id, handleInnerFormChange, selectedAccountUsers, accountTypesList
}: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="First Name"
                            name="FirstName"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'FirstName',
                                );
                            }}
                            type="text"
                            value={selectedAccountUsers?.FirstName}
                        />
                        <InputContainer
                            label="Last Name"
                            name="LastName"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'LastName',
                                );
                            }}
                            type="text"
                            value={selectedAccountUsers?.LastName}
                        />
                        <InputContainer
                            label="Company Name"
                            name="CompanyName"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'CompanyName'
                                )
                            }}
                            type="text"
                            value={selectedAccountUsers?.CompanyName}
                        />
                        <InputContainer
                            label="Phone Number"
                            name="PhoneNumber"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'PhoneNumber',
                                );
                            }}
                            type="number"
                            value={selectedAccountUsers?.PhoneNumber}
                        />
                        <InputContainer
                            label="Email"
                            name="Email"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Email',
                                );
                            }}
                            type="text"
                            value={selectedAccountUsers?.Email}
                        />
                        <InputContainer
                            icon
                            label="Password"
                            name="Password"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Password',
                                );
                            }}
                            type="password"
                            value={selectedAccountUsers?.Password}
                        />
                        <InputContainer
                            label="User Type"
                            labelField="Name"
                            list={accountTypesList}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'UserType',
                                );
                            }}
                            optionName='Choose UserType'
                            type="select"
                            value={selectedAccountUsers?.UserType}
                            valueField="Name"
                        />
                    </div>
                }
                expandedPanel="userInfo"
                headerTitle="User Information"
            />
        </>
    )
}
export default AccountUserBasicInfoComponent;
